export class AdminAuditModel {
    constructor(data) {
        this.id = data.id;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.emailActor = data.emailActor;
        this.emailTarget = data.emailTarget;
        this.action = data.action;
        this.value = data.value;
        this.description = data.description;
    }
}
